/**
 * Module-level bridge between the `ui.render_email_cards` handler and the
 * React `useChat` hook. Mirrors the pill-bridge pattern.
 */

import type { EmailSearchResult } from "../../../src/integrations/email/types";

type EmailCardSink = (cards: EmailSearchResult[], querySummary: string) => void;

let sink: EmailCardSink | null = null;

export function registerEmailCardSink(next: EmailCardSink): () => void {
  sink = next;
  return () => {
    if (sink === next) sink = null;
  };
}

export function emitEmailCards(cards: EmailSearchResult[], querySummary: string): void {
  sink?.(cards, querySummary);
}
